import styles from './ScanField.module.css';

export type ScanResult = { readonly tone: 'accepted' | 'refused'; readonly message: string };

export type ScanOutcomeProps = { result: ScanResult | null };

export const ScanOutcome = ({ result }: ScanOutcomeProps) => (
  <div aria-live="polite">
    {result === null ? null : (
      <p className={styles[result.tone]} role={result.tone === 'refused' ? 'alert' : 'status'}>
        {result.message}
      </p>
    )}
  </div>
);
